/*───────────────────────────────────────────────────────────────
 📄 File: components/webrtc/WebRTCToggleButton.tsx
 🧩 Description:
    Floating phone toggle button that slides into view when the
    WebRTC panel is closed. Extracted from WebRTCPhonePanel.tsx.
────────────────────────────────────────────────────────────────*/

import { Phone } from 'lucide-react';

interface Props {
    isOpen: boolean;
    status: string;
    onToggle: () => void;
}

export function WebRTCToggleButton({ isOpen, status, onToggle }: Props) {
    return (
        <button
            onClick={onToggle}
            className={`fixed right-0 top-1/2 -translate-y-1/2 z-40 p-2 rounded-l-lg transition-all duration-300 ${
                isOpen ? 'translate-x-full opacity-0' : 'translate-x-0 opacity-100'
            } ${status === 'registered' ? 'bg-green-600 hover:bg-green-700' : 'bg-muted hover:bg-muted/80'} text-white shadow-lg`}
        >
            <Phone className="w-5 h-5" />
        </button>
    );
}
